import { Group, Stack, Text, useMantineTheme } from '@mantine/core';

import { type OpportunityAssessment } from '../../../types/apiTypes';
import { getBidDecisionString, getScoreString } from '../../../utils/stringUtils';

interface Props {
  assessment: OpportunityAssessment
}
const OpportunityAssessmentPanel: React.FC<Props> = (props: Props) => {
  const { assessment } = props;
  const { other: colorVars } = useMantineTheme();
  const oppSummary = <Stack gap={8}>
    <Text fz='lg' fw={500}>
      Analysis Results
    </Text>
    <Text fz='sm' c={colorVars.secondaryTextColor}>
      {assessment.summary ?? 'No summary available for this opportunity.'}
    </Text>
  </Stack>;

  const summary = <Stack gap={8}>
    <Text fz='sm' fw={500}>
      Opportunity Summary
    </Text>
    <Text fz='sm' c={colorVars.secondaryTextColor}>
      {assessment.opportunity.summary ?? 'No explanation available for this assessment.'}
    </Text>
  </Stack>;

  const scoreGroups = <Group gap={32}>
    <Stack gap={0}>
      <Text fz='sm' fw={500}>
        Score
      </Text>
      <Text fz={24}>
        {getScoreString(assessment?.score ?? undefined)}
      </Text>
    </Stack>
    <Stack gap={0}>
      <Text fz='sm' fw={500}>
        Recommendation
      </Text>
      <Text fz={24}>
        {getBidDecisionString(assessment?.bid_decision ?? undefined)}
      </Text>
    </Stack>
  </Group>;

  const filesList = <Stack gap={8}>
    <Text fz='sm' fw={500}>
      Files Evaluated
    </Text>
    <Stack gap={0}>
      {assessment.opportunity.files?.map(
        (file) => (
          <Text
            fz='sm'
            c={colorVars.secondaryTextColor}
            key={file.uid}
          >
            {file.file_name}
          </Text>)
      )}
    </Stack>
  </Stack>;

  return (
    <Stack>
      {oppSummary}
      {scoreGroups}
      {summary}
      {filesList}
    </Stack>
  );
};

export default OpportunityAssessmentPanel;
